var PowerState;
(function (PowerState) {
    PowerState["None"] = "None";
    PowerState["Running"] = "Running";
    PowerState["Starting"] = "Starting";
    PowerState["Stopping"] = "Stopping";
    PowerState["Stopped"] = "Stopped";
})(PowerState || (PowerState = {}));
export default PowerState;
